import React, { useEffect } from 'react';
import {
  RouteProps as ReactDOMRouteProps,
  Route as ReactDOMRoute,
  Redirect
} from 'react-router-dom';

import { useAuth } from '../hooks/AuthContext';
import moment from 'moment';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType
}

const Route: React.FC<RouteProps> = ({ isPrivate = false, component: Component, ...rest }) => {
  const { isAuth, store, expiration, signOut } = useAuth();

  const expired = moment().isAfter(moment(expiration));

  useEffect(() => {
    if (expired) {
      signOut();
    }
  }, [expired, signOut]);

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        if (isAuth && location.pathname === '/' && store) {
          return (
            <Redirect
              to={{
                pathname: '/dashboard',
                state: { from: location },
              }}
            />
          );
        }

        if (!isPrivate) {
          return <Component />;
        }

        if (!isAuth) {
          return (
            <Redirect
              to={{
                pathname: '/',
                state: { from: location },
              }}
            />
          );
        }

        if (isAuth && !store) {
          return (
            <Redirect
              to={{
                pathname: '/login-monitor-store',
                state: { from: location },
              }}
            />
          );
        }

        return <Component />;
      }}
    />
  );
}

export default Route;
